// utilities
import { sendRequest } from '../../../utilities/http';
import endpointsMap from '../../../utilities/endpoints';
// helpers/constants
import * as GC from '../../../constants';
import { ENUMS } from '../../../constants/enums';
// feature driver-cards-v2
import { RESOURCE_MODE_TRUCK } from '../constants';
//////////////////////////////////////////////////

export const requestAssignedResources = (resourceMode, resourceGroupBy, options) => {
  let endpoint = endpointsMap.assignedLoadsList;

  if (resourceMode === RESOURCE_MODE_TRUCK) {
    endpoint = endpointsMap.telDriverCardsByTruckAssignedLoadsList;
  } else if (resourceGroupBy === ENUMS.ENUM_NONE) {
    endpoint = endpointsMap.assignedLoads;
  }

  return sendRequest('post', endpoint, options);
};

export const requestDriverCardsConfigs = (branchGuid, names) => sendRequest(
  'get',
  endpointsMap.branchConfigsEndpoint,
  {
    params: {
      names: names.join(','),
      [GC.FIELD_BRANCH_GUID]: branchGuid,
    },
  },
);

export const requestResourceGroupInfo = (resourceMode, branchGuid) => {
  const endpoint = resourceMode === RESOURCE_MODE_TRUCK
    ? endpointsMap.telDriverCardsByTruckInfo
    : endpointsMap.telDriverCardsInfo;

  return sendRequest('get', endpoint, { params: { enterpriseGuid: branchGuid } });
};

export const requestUnassignedLoads = (options) => (
  sendRequest('post', endpointsMap.unassignedLoads, options)
);

export const requestUpdateDriverCards = (options) => (
  sendRequest('put', endpointsMap.updateDriverCards, options)
);

export const requestEventReferences = (eventGuids) => (
  sendRequest('post', endpointsMap.cloReferenceByEventGuids, { data: eventGuids })
);

export const requestLoadDetails = (loadId) => (
  sendRequest('get', endpointsMap.getTelEndpoint(loadId))
);
